import TreeWrapper from '../tree/TreeWrapper';
import React from 'react';

const PortfolioTreeWrapper = (props) => {
    return <TreeWrapper {...props} classNamePrefix="portfolio" />;
};

export default PortfolioTreeWrapper;
